import { ConfigService, TrackerService } from '../services';
import { Storage } from '../constants';
import { Routes } from '../Routes';
import { ConfigurationStore, CreditsStore, NotificationStore, ParentStore, SitterStore, UserStore, VerificationStore } from '../models';
import { ReviewFlowStore } from '../models/ReviewFlowStore';
import { FacebookSdk } from 'us-react-components/dist/utils/FacebookSdk';

export class Environment {
  services: {
    config: ConfigService;
    tracker: TrackerService;
  };

  stores: {
    configuration: ConfigurationStore;
    credits: CreditsStore;
    notifications: NotificationStore;
    parent: ParentStore;
    sitter: SitterStore;
    user: UserStore;
    reviewFlow: ReviewFlowStore;
    verification: VerificationStore;
  };

  constructor() {
    if (!localStorage.getItem(Storage.US_USER_AUTH_TOKEN) || !localStorage.getItem(Storage.US_USER_OBJECT)) {
      window.location.href = `${Routes.login}?redirectTo=${encodeURIComponent(window.location.pathname)}`;
    }

    const config = new ConfigService();
    const configuration = new ConfigurationStore();
    const user = new UserStore();
    const notifications = new NotificationStore(user);
    const sitter = new SitterStore(user);
    const parent = new ParentStore();
    const credits = new CreditsStore(user);
    const reviewFlow = new ReviewFlowStore();
    const verification = new VerificationStore(user);

    this.stores = { configuration, credits, notifications, parent, sitter, user, reviewFlow, verification };

    // order matters, these service depend on stores
    const tracker = new TrackerService(config, this);

    this.services = {
      config,
      tracker,
    };
    FacebookSdk.preload();
  }

  async setup(): Promise<void> {
    await this.stores.user.refreshUser();

    if (this.stores.user.user?.sitter) {
      await this.stores.sitter.refreshSitter();
    }

    await this.stores.verification.getUserVerification();
  }
}
